import stylex from '@stylexjs/stylex';
import { dataProps } from '../helpers/dataProps';
export const stylePropsFactory = (combineStyles, visualState) => (...styleKeys) => ({
    ...stylex.props(...(styleKeys
        ? combineStyles(...styleKeys.flat())
        : [])),
    ...dataProps(visualState),
});
